export var getContentstackImageURL = function getContentstackImageURL(originalURL, width, options) {
  var url = new URL(originalURL);
  url.searchParams.set('width', width.toString());
  url.searchParams.set('auto', 'webp');
  url.searchParams.set('quality', '70');
  if (options !== null && options !== void 0 && options.aspectRatio) {
    url.searchParams.set('crop', options.aspectRatio);
  }
  if (options !== null && options !== void 0 && options.height) {
    url.searchParams.set('height', options.height.toString());
  }
  return url.toString();
};
export var getContentstackImagesForWidths = function getContentstackImagesForWidths(originalURL, widths, options) {
  return widths.map(function (width) {
    return {
      src: getContentstackImageURL(originalURL, width, options),
      width
    };
  });
};